import type {Json, NodeParameters} from "@cm/graph-v3"
import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"
import {TemplateNode} from "#template/template-node/template-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import type {JsonLikeNode} from "#template/nodes/json/fundamental"
import {jsonLikeMarker} from "#template/nodes/json/fundamental"
import {fundamentalLikeMarker} from "#template/role-markers"
import type {NodeEvaluator} from "#template/node-evaluator"

export abstract class JsonNode<out Parameters extends NodeParameters = NodeParameters, out ConstructorParameters extends NodeParameters = Parameters>
    extends TemplateNode<Parameters, ConstructorParameters>
    implements JsonLikeNode
{
    get [jsonLikeMarker]() {
        return true as const
    }
    get [fundamentalLikeMarker]() {
        return true as const
    }

    public abstract override get definition(): TemplateNodeDefinition<Parameters, ConstructorParameters>

    public abstract evaluate(scope: GraphBuilderScope, evaluator: NodeEvaluator): BuilderInlet<Json | null>
}
